import { MediaGallerySidenavController } from "./media-gallery-sidenav.controller";
import { MediaGallerySidenavUploadMediaDialogController } from "./upload-media-dialog.controller";
import { MediaGallerySidenavUploadMediaService } from "./upload-media.service";

import angularDragula from "angular-dragula";

angular
    .module("thor.shared.media-gallery-sidenav.component", [
        angularDragula(angular)
    ])
    .component("mediaGallerySidenav", {
        bindings: {
            close: "&",
            closeSidenav: "&",
            resource: "=",
            readOnly: "<"
        },
        controller: MediaGallerySidenavController,
        template: require("../../../shared/media-gallery/media-gallery-sidenav/media-gallery-sidenav.html")
    })
    .service("mediaGallerySidenavUploadMediaService", MediaGallerySidenavUploadMediaService)
    .controller("MediaGallerySidenavUploadMediaController", MediaGallerySidenavUploadMediaDialogController);
